import React from "react";

import MultiSelectFilter from "components/filters/MultiSelectFilter";
import { useAppSelector } from "store";
import { chooseAllPlaceSuperCategories, deselectAllPlaceSuperCategories, selectPlaceSuperCategories, togglePlaceSuperCategoryIsSelected } from "modules/customer/tools/location/retailers/retailersSlice";


const PlaceSuperCategoriesDropdown: React.FC = () => {
    const placeSuperCategories = useAppSelector(selectPlaceSuperCategories);
    return (
        <MultiSelectFilter
            title="Store categories"
            allItemsChosenSubtitle="All categories"
            items={placeSuperCategories}
            chooseAllItems={chooseAllPlaceSuperCategories}
            deselectAllItems={deselectAllPlaceSuperCategories}
            toggleItemIsSelected={togglePlaceSuperCategoryIsSelected}
        />
    );
};

export default PlaceSuperCategoriesDropdown;
